import * as actionType from '../constants/constant.action'

const defaultState = {
  showModal: false,
}

const providerDetailsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionType.PROVIDER_DETAILS_REQUEST_ASYNC:
      return {
        ...state,
        loading: true,
      }
    case actionType.PROVIDER_DETAILS_REQUEST_SUCCESS:
      return {
        ...action.payload,
        showModal: true,
        loading: false,
      }
    case actionType.PROVIDER_DETAILS_REQUEST_FAILURE:
      return {
        ...action.payload,
        showModal: false,
        loading: false,
        serverError: true,
      }

    case actionType.CLOSE_PROVIDER_DETAILS_MODAL:
      return {
        ...action.payload,
        showModal: false,
      }
    default:
      return state
  }
}

export default providerDetailsReducer
